// === FILENAME: src/data/sponsorsData.js ===
export const sponsorsData = [
  { id: 1, name: "Constructora Regional", url: "#" },
  { id: 2, name: "Ferretería El Dique", url: "#" },
  { id: 3, name: "Turismo Sierra Norte", url: "#" },
  { id: 4, name: "Banco Córdoba", url: "#" },
  { id: 5, name: "Supermercados Valle", url: "#" },
  { id: 6, name: "Clinica del Lago", url: "#" },
  { id: 7, name: "Agro Serrano", url: "#" },
  { id: 8, name: "Transporte Andino", url: "#" },
];
